import { ReactNode } from 'react';

const WhyCards = () => (
  <section id="why-section" className="bg-common-white text-[#151012] pt-28 px-4 text-center">
    <h3 className="font-primary text-title md:text-heroTitle !font-extraBold mt-2">
      Why choose SATPrac?
    </h3>

    <div className="flex items-center flex-col gap-24 py-16 md:py-32">
      <CardItem index={1} top={200}>
        <strong className="block text-[1.125rem] ml-auto w-full sm:max-w-[16rem] sm:-mr-6 mb-5 font-semibold">
          SATPrac site is different from all other prep courses
        </strong>
        <ul className="list-disc text-callout sm:text-body pl-7">
          <li>NO gimmicks</li>
          <li>NO AI window dressing</li>
          <li>NO schedule maker that generically spits out what you should do on a given day.</li>
          <li>
            NO guarantees other than quite simply: If you put the time and use these materials to the fullest,
            it’s not a matter of IF you will win the digital SAT… it’s simply a matter of WHEN.
          </li>
        </ul>
      </CardItem>
      <CardItem index={2} top={240}>
        <strong className="font-extraBold text-[1.125rem] sm:text-[2rem] text-[#FEE7E1] leading-[110%]">
          SATPrac adapts with the test
        </strong>
        <p className="mt-8 text-callout sm:text-body text-[#FEE7E1]">
          Idiot tutor Mark Anestis is constantly adding new questions to the SATPrac site to reflect
          any changes to the real test. Any time a new test or practice pack is added to SATPrac, it
          will automatically appear on your personal dashboard.
        </p>
      </CardItem>
      <CardItem index={3} top={280}>
        <p className="font-primary text-body sm:text-[1.25rem] leading-normal">
          Practice test score reports show students exactly which questions they missed, and,
          more importantly, how to classify each question by <strong className="font-extraBold">TYPE</strong>.
        </p>
      </CardItem>
      <CardItem index={4} top={320}>
        <strong className="block mt-14 mb-4 font-semibold">
          The video tutorials that help you with strategies, studying methods, and scheduling, including:
        </strong>
        <ul className="list-disc text-[13px] sm:text-callout leading-normal pl-7">
          <li>Showing you how to make notecards that can greatly enhance your memory building process.</li>
          <li>
            Showing you how to attack the modules in different ways so you can decide which approach
            is most efficient and effective for you.
          </li>
          <li>Helping you come up with a study schedule that gives you the best chance to hit your target score.</li>
        </ul>
      </CardItem>
      <CardItem index={5} top={360}>
        <p className="font-primary text-body sm:text-[1.25rem] leading-normal">
          SATPrac is built and run by Idiot Tutor Mark Anestis, who has
          helped thousands of students hit their goal score on the SAT. He is ready to assist you when
          needed. Just hit that CONTACT IDIOT TUTOR button and reach out!
        </p>
      </CardItem>
    </div>
  </section>
);

const CardItem = ({
  index,
  top = 200,
  children
}: {
  index: number;
  top?: number;
  children: ReactNode
}) => {
  const color = COLORS[index as keyof typeof COLORS];

  return (
    <div
      className={`w-full max-w-[26.75rem] h-[28.375rem] sticky text-left`}
      style={{ top }}
    >
      <div
        className="relative overflow-hidden flex items-center justify-center w-full h-full
        rounded-[2.5rem] py-[3.75rem] px-[1rem] sm:px-[3.75rem]"
        style={{ backgroundColor: color.bg, color: color.text }}
      >
        <span
          className="absolute left-5 top-0 -rotate-[15deg] text-[3rem] sm:text-[5rem] leading-normal font-extraBold"
          style={{ color: color.index }}>
          0{index}
        </span>
        <div>{children}</div>
      </div>
    </div>
  );
};

const COLORS = {
  1: {
    bg: '#0000000D',
    text: '#000000',
    index: '#DBDBDB',
  },
  2: {
    bg: '#2F2027',
    text: '#FEE7E1',
    index: '#6A4D5C',
  },
  3: {
    bg: '#FF3F70',
    text: '#FFFFFF',
    index: '#FC929F',
  },
  4: {
    bg: '#3030F2',
    text: '#FFFFFF',
    index: '#9191F3',
  },
  5: {
    bg: '#008281',
    text: '#FFFFFF',
    index: '#01BCBC',
  },
};

export default WhyCards;
